<template>
  <div>
    <ModuleHeader>Reporte Transacciones</ModuleHeader>
    <v-card flat>
      <v-card-text>
        <v-form>
          <v-row>
            <v-col cols="6" md="6">
              <label>Fecha inicial</label>
              <div style="border-bottom: 1px solid; margin-bottom: -1px">
                <Datepicker :input-class="'v-input__control theme--light v-text-field dateinputClass '"
                  @input="getAperturas()" @selected="selectDate" :value="input_date.format('MM/DD/YYYY')"></Datepicker>
              </div>
            </v-col>
            <v-col cols="6" md="6">
              <div style="border-bottom: 1px solid; margin-bottom: -1px">
                <label>Fecha final</label>
                <Datepicker :input-class="'v-input__control theme--light v-text-field dateinputClass '"
                  @input="getAperturas()" @selected="selectDateFinal" :disabled-dates="disableDates"
                  :value="input_date_final.format('MM/DD/YYYY')"></Datepicker>
              </div>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <div class="buttons-container"></div>
            </v-col>
          </v-row>
        </v-form>

        <v-row>

          <v-col md="3" cols="6">
            <v-autocomplete @input="getAperturas()" label="Departamentos" v-model="selectDep" item-text="Nombre"
              item-value="id" :items="departamentos"></v-autocomplete>
          </v-col>
          <v-col cols="12" md="3">
            <v-autocomplete label="Turno" v-model="selectTurno" item-value="Turno" item-text="Desc" :items="turnosList">
              <template v-slot:append-outer>
                <v-btn @click="getAperturas()" small color="primary">Buscar turnos</v-btn>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col md="3" cols="6">
            <v-select v-model="pagos" :items="getPDVPagosTipos" item-value="id" item-text="Nombre"
              label="Metodos de pago" multiple></v-select>
          </v-col>
          <v-col md="3" cols="6">
            <v-select v-model="monedas" :items="getPDVMonedasLista" item-value="id" item-text="Nombre" label="Moneda"
              multiple></v-select>
          </v-col>
          <v-col md="3" cols="6" class="mt-n6">
            <v-autocomplete v-model="clientesSelected" :items="comp_clients" item-value="id" item-text="text"
              label="Cliente" multiple>
              <template v-slot:append-outer>
                <v-btn small @click="clientesSelected = []" color="primary">Todos</v-btn>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col md="3" cols="6" class="mt-n6">
            <v-text-field v-model="transaccion" label="Autorización (Opcional)"></v-text-field>
          </v-col>
          <v-col md="3" cols="6" class="mt-n6">
            <v-autocomplete label="Caja" @input="getAperturas()" v-model="selectCaja" item-value="id" item-text="Nomb"
              :items="data_cajas"></v-autocomplete>
          </v-col>
          <v-col md="3" cols="6" class="mt-n6">
            <v-select v-model="input_cajero" :items="cajeros" item-value="Id" item-text="Nomb"
              label="Cajero"></v-select>
          </v-col>
          <v-col md="3" cols="6" class="mt-n6">
            <v-text-field v-model="input_folio" label="Folio de Venta"></v-text-field>
          </v-col>
          <v-col md="3" cols="6" class="mt-n6">
            <v-text-field v-if="$store.getters.getFirebaseApp.tenant == 'BOKA'" v-model="input_id" label="Identificador unico"></v-text-field>
          </v-col>
        </v-row>
        <v-btn @click="buscar()" :loading="loadingData" :disabled="loadingData" color="success" class="ma-1">
          Buscar
        </v-btn>
      </v-card-text>
    </v-card>
    <h4>Contadores totales del día (incluye propina y cambio)</h4>
    Tabla de totales
    <v-simple-table>
      <thead>
        <tr>
          <th>Corte</th>
          <template v-for="(data, index) in contadoresTotales.encabezados">
            <th :key="index">{{ index }}</th>
          </template>
        </tr>
      </thead>
      <tbody>
        <template v-for="(caja, cajaidx) in contadoresTotales.dataContador">
          <tr :key="cajaidx">
            <td>
              {{ cajeroNombre(cajaidx) }}
            </td>
            <template v-for="(data, indexEnc) in contadoresTotales.encabezados">
              <td :key="indexEnc + cajaidx">
                {{
                  $pgsHelper.formatNumber(
                    (caja[indexEnc] ? caja[indexEnc] : 0) -
                    (indexEnc == ("EFVO_" + Currency.getCurrencyDefault()) ? caja["Cambio"] : 0)
                  )
                }}
              </td>
            </template>
          </tr>
        </template>
        <tr>
          <td>TOTALES</td>
          <template v-for="(data, indextot) in contadoresTotales.encabezados">
            <td :key="indextot + 'tot'">
              <b>
                {{
                  $pgsHelper.formatNumber(
                    contadoresTotales.totales[indextot] -
                    (indextot == ("EFVO_" + Currency.getCurrencyDefault())
                      ? contadoresTotales.totales["Cambio"]
                      : 0)
                  )
                }}
              </b>
            </td>
          </template>
        </tr>
      </tbody>
    </v-simple-table>
    <div>
      <v-row>
        <v-col md="2"> Resultados: </v-col>
        <v-col md="3" class="text-right">
          <v-btn @click="generatePdfCliente()" color="red" dark><v-icon>mdi-file-pdf-box</v-icon>
            Agrupado por Cliente
          </v-btn>
        </v-col>
        <v-col md="3" class="text-right">
          <v-btn @click="generatePdf()" color="red" dark><v-icon>mdi-file-pdf-box</v-icon>
            Agrupado por Meto Pago
          </v-btn>
        </v-col>
        <v-col md="3" class="text-right">
          <v-btn color="green" dark @click="exportExcel"><v-icon>mdi-file-excel-box</v-icon>
            Exportar a Excel
          </v-btn>
        </v-col>
      </v-row>
      <v-data-table class="dense-table" :headers="headers" :items="tableRows" item-key="_key" :loading="loadingData"
        :items-per-page="50" :footer-props="{ itemsPerPageOptions: [25, 50, 100, 200] }" disable-sort dense
        loading-text="Cargando..." no-data-text="No se encontraron datos">
        <template v-slot:item="{ item: res }">
          <tr v-if="res.esDevolucion" :class="{ backgroundProp: res.prop }">
            <td>
              <b>{{ res.Folio }}</b>
            </td>
            <td>{{ res.Fecha }}</td>
            <td>{{ formatDate(res.Crat) }}</td>
            <td>
              <b>{{ res.IdTran }}</b>
            </td>
            <td>{{ res.Cliente.Apodo }}</td>
            <td>{{ res.Cliente.Nombre }}</td>
            <td></td>
            <td>{{ cajeroNombre(res.Cajero) }}</td>
            <td>{{ res.TipoPago }}</td>
            <td>
              <b>${{ $pgsHelper.formatNumber($pgsHelper.roundDecimals(res.Cantidad)) }}</b>
            </td>
            <td>{{ $pgsHelper.formatNumber(res.Cantidad) }}</td>
            <td></td>
            <td>
              <b class="orange--text">Devolución</b>
            </td>
            <td style="white-space: nowrap"></td>
          </tr>
          <tr v-else :class="[res.prop ? 'backgroundProp' : '', res.camb ? 'backgroundCamb' : '']">
            <td>
              <b>{{ res.Folio }}</b>
            </td>
            <td>{{ res.FechaVenta }}</td>
            <td>{{ formatDate(res.FechaCreacion) }}</td>
            <td>
              <b>{{ res.IdTran }}</b>
            </td>
            <td>{{ res.Cliente.Apodo }}</td>
            <td>{{ res.Cliente.Nombre }}</td>
            <td style="font-size: 12px">Mesero: {{ res.Mesero.Nombre }}</td>
            <td>{{ cajeroNombre(res.Cajero) }}</td>
            <td>{{ res.TipoPago }}</td>
            <td>
              <b>${{ $pgsHelper.formatNumber(res.Cantidad) }} {{ res.moneda }}</b>
            </td>
            <td>{{ $pgsHelper.formatNumber(res.Total) }}</td>
            <td>
              <b>{{ $pgsHelper.formatNumber(res.PropinaTotal + res.Total) }}</b>
            </td>
            <td>
              <b v-show="!res.camb" :class="res.Devos ? 'blue--text' : 'green--text'">{{ res.Devos ? "Devuelto" :
                "Activo" }}</b>
            </td>
            <td>
              <v-btn @click="showDetail(res)" small color="success">
                Detalles
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>
    <modal v-model="showModal" :showFooter="false" title="Detalle de la venta">
      <resumenVenta :selectedRes="selectedRes" />
    </modal>
  </div>
</template>

<script>
import "../../assets/css/custom.css";
import "../../assets/css/sideBar.css";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import modal from "../MainComponents/modal.vue";
import { mapGetters } from "vuex";
import resumenVenta from "../MainComponents/resumenVenta.vue";
import pdfmake from "pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfmake.vfs = pdfFonts.pdfMake.vfs;
import ReporteMetodosPago from "../../clases/PdfMakers/ReporteMetodosPago.js";
import ReporteMetodosPagoCliente from "../../clases/PdfMakers/ReporteMetodosPagoCliente.js";
import TransaccionesExcelExporter from "../../clases/ExcelMaker/ReporteTransaccionesExcel.js";
import Currencies from "../../clases/Currencies.js";
import {
  buildVentaRows,
  buildDevolucionRows,
  buildContadores,
  sortByFolio,
} from "../../clases/ReporteTransaccionesBuilder.js";
import { queryPorTurnos } from "../../clases/FirestoreTurnos.js";

export default {
  name: "ReporteTransacciones",
  components: {
    Datepicker,
    resumenVenta,
    modal,
  },
  props: ["hideMenu"],
  data() {
    return {
      headers: [
        "Folio venta",
        "Fecha",
        "Hora",
        "Id Autorización",
        "Alias",
        "Cliente",
        "Extra",
        "Cajero",
        "Tipo de pago",
        "Cantidad Metodo de pago",
        "Total Venta",
        "Total Ticket",
        "Estatus",
        "Opciones",
      ].map((text) => ({ text, sortable: false })),
      Currency: Currencies,
      selectTurno: "ALL",
      aperturas: [],
      clientesSelected: [],
      meseros: [],
      selectCaja: "",
      pagos: [],
      monedas: [],
      transaccion: "",
      loadingData: false,
      input_date: moment(),
      input_date_final: moment(),
      selectedRes: "",
      input_cajero: "",
      input_folio: "",
      input_id: "",
      data_cajas: [],
      showModal: false,
      selectDep: "ALL",
      cajeros: [{ id: "ALL", Nomb: "Todos" }],
      // Resultados de la búsqueda: se asignan ya congelados (Object.freeze)
      // para que Vue 2 no observe en profundidad miles de objetos.
      data_ventas: Object.freeze([]),
      data_devoluciones: Object.freeze([]),
      contadoresTotales: Object.freeze({
        dataContador: {},
        encabezados: {},
        totales: { Cambio: 0 },
      }),
    };
  },
  computed: {
    ...mapGetters(["getFirebaseApp"]),
    ...mapGetters(["getClientes", "getPDVPagosTipos", "getPDVMonedasLista"]),
    turnosList() {
      return [{ Turno: "ALL", Desc: "Todos", CajeroName: "Todos" }, ...this.aperturas];
    },
    departamentos() {
      return [
        { id: "ALL", Nombre: "Todos" },
        ...this.$store.getters.getPDVDepartamentos,
      ];
    },
    disableDates() {
      return { to: new Date(this.input_date) };
    },
    comp_clients() {
      return this.getClientes.map((cli) => ({
        id: cli.id,
        text: cli.Apellidos + " " + cli.Nombres,
      }));
    },
    cajerosNombres() {
      return new Map(this.cajeros.map((c) => [c.Id, c.Nomb]));
    },
    // Filas visibles (respetando filtros de pago/cliente aplicados al buscar)
    tableRows() {
      return this.data_ventas
        .concat(this.data_devoluciones)
        .filter((r) => r.show);
    },
    // Insumo de los PDF
    excel_data() {
      const ventas = this.data_ventas
        .filter((v) => v.show)
        .map((venta) => ({
          Folio: venta.Folio,
          Fecha: venta.FechaVenta,
          Hora: this.formatDate(venta.FechaCreacion),
          Cliente: venta.Cliente.Nombre,
          Alias: venta.Cliente.Apodo,
          Cajero: this.cajeroNombre(venta.Cajero),
          Autorizacion: venta.IdTran,
          Clave: venta.clave,
          TipoPago: venta.TipoPago,
          Moneda: venta.moneda,
          TotalMetodoPago: venta.Cantidad,
          TotalVenta: this.$pgsHelper.formatNumber(venta.Total),
          TotalTicket: this.$pgsHelper.formatNumber(
            venta.PropinaTotal + venta.Total
          ),
          Estatus: venta.Devos ? "Devuelto" : "Activo",
          Tipo: venta.prop ? "Propina" : venta.camb ? "Cambio" : "Pago",
        }));
      const devoluciones = this.data_devoluciones
        .filter((d) => d.show)
        .map((venta) => ({
          Folio: venta.Folio,
          Fecha: moment(venta.Fecha).format("YYYY-MM-DD"),
          Hora: this.formatDate(venta.Crat),
          Cliente: venta.Cliente.Nombre,
          Alias: "Devolución",
          Cajero: this.cajeroNombre(venta.Cajero),
          Autorizacion: venta.IdTran,
          Clave: venta.clave,
          Moneda: venta.moneda,
          TipoPago: venta.TipoPago,
          TotalMetodoPago: 0 - venta.Cantidad,
          TotalVenta: this.$pgsHelper.formatNumber(venta.Cantidad),
          Cambio: 0,
          Estatus: "Devolucion",
          Tipo: venta.prop ? "Propina" : "Pago",
        }));
      return ventas.concat(devoluciones).sort(sortByFolio);
    },
  },
  methods: {
    cajeroNombre(id) {
      return this.cajerosNombres.get(id) ?? id;
    },
    exportExcel() {
      TransaccionesExcelExporter.exportReporteTransacciones(
        this.data_ventas,
        this.data_devoluciones,
        "Reporte transacciones",
        this.contadoresTotales, this.cajeros
      )
        .then(buffer => {
          const blob = new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = "ReporteTransacciones.xlsx";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch(err => console.error("Error exportando Excel:", err));
    },
    async getAperturas() {
      const startDate = this.input_date.format("YYYY-MM-DD");
      const endDate = this.input_date_final.format("YYYY-MM-DD");
      const end = endDate.replace(/.$/, (c) =>
        String.fromCharCode(c.charCodeAt(0) + 1)
      );
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      let filter = [
        firestore.where("Momento", ">=", startDate),
        firestore.where("Momento", "<", end),
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
        //firestore.where("Caja", "==", this.$route.params.idInstalacion),
        firestore.where("Tipo", "==", "Apertura"),
      ];
      if (this.selectDep != "ALL" && this.selectDep != "") {
        filter.push(
          firestore.where("Departamentos", "array-contains", this.selectDep)
        );
      }
      if (this.selectCaja != "ALL" && this.selectCaja != "") {
        filter.push(firestore.where("Caja", "==", this.selectCaja));
      }
      const data = await firestore.queryBuilder("PDV_CierreApertura", filter);
      //console.log(cierres);
      let aperturas = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });

      aperturas.forEach((apt) => {
        let fecha = new moment(apt.Momento, "YYYY-MM-DD_HH:mm:ss");
        let caja = this.$pgsHelper.getById(this.data_cajas, "id", apt.Caja);
        let cajeroData = this.$pgsHelper.getById(
          this.cajeros,
          "Id",
          apt.Cajero
        );
        apt.CajaData = caja;
        apt.CajeroData = cajeroData;
        apt.CajeroName = cajeroData.Nomb;
        apt.Desc =
          "Turno Fecha " +
          fecha.format("DD-MM-YYYY") +
          " Hora: " +
          fecha.format("HH:mm") +
          " || " +
          caja.Nomb +
          " || " +
          cajeroData.Nomb +
          " || Turno: " +
          apt.Turno;
      });

      this.aperturas = aperturas;
    },
    generatePdf() {
      let mainData = {
        FI: this.input_date.format("DD/MM/YYYY"),
        FF: this.input_date_final.format("DD/MM/YYYY"),
        FG: new moment().format("DD/MM/YYYY"),
        HG: new moment().format("HH:mm:ss"),
        data: this.excel_data,
      };
      let docData = ReporteMetodosPago.getDocData(mainData);
      pdfmake.createPdf(docData).open();
    },
    generatePdfCliente() {
      let mainData = {
        FI: this.input_date.format("DD/MM/YYYY"),
        FF: this.input_date_final.format("DD/MM/YYYY"),
        FG: new moment().format("DD/MM/YYYY"),
        HG: new moment().format("HH:mm:ss"),
        data: this.excel_data,
      };
      let docData = ReporteMetodosPagoCliente.getDocData(mainData);
      pdfmake.createPdf(docData).open();
    },
    async getMeserosAB() {
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "AYB/Meseros"
        );
      if (snapshot.exists()) {
        this.meseros = [];
        this.meseros = this.$pgsHelper.ArrayObjectToArray(snapshot.val());
        this.meseros.forEach((mesero) => {
          if (mesero.Deptos) {
            let deptos = Object.entries(mesero.Deptos);
            let textDepto = "";
            deptos.forEach((depto) => {
              let testDepto = this.$pgsHelper.getById(
                this.departamentos,
                "Id",
                depto[0]
              );
              if (testDepto) {
                textDepto = textDepto + testDepto.Nombre + " ";
              }
            });
            mesero.DepartamentoText = textDepto;
          } else {
            mesero.DepartamentoText = "";
          }
        });
      }
    },
    formatDate(timestamp) {
      let d = new Date(timestamp);
      //console.log(new moment(d))
      //let Creacion =   d.getDate()  + "-" + (d.getMonth()+1) + "-" + d.getFullYear() + " " + d.getHours() + ":" + d.getMinutes();
      return new moment(d).format("HH:mm");
    },
    async getCajas() {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/Cajas"
        );
      this.data_cajas = this.$pgsHelper.ArrayObjectToArray(data.val());
    },
    showDetail(res) {
      // las filas están congeladas: se arma una copia con las listas del detalle
      const venta = res.venta;
      this.selectedRes = {
        ...venta,
        ListProducts: Object.entries(venta.Catalogo || {}),
        ListPagos: Object.entries(venta.Pagos || {}),
      };
      this.showModal = true;
    },
    selectDate(arg) {
      this.input_date = moment(arg);
      this.input_date_final = moment(arg);
    },
    selectDateFinal(arg) {
      this.input_date_final = moment(arg);
    },
    turnosSeleccionados() {
      if (this.selectTurno != "ALL") return [this.selectTurno];
      return this.aperturas.map((a) => a.Turno);
    },
    // Filtros comunes a ventas y devoluciones
    filtrosBusqueda(firestore) {
      const filter = [];
      if (this.input_folio != "") {
        filter.push(firestore.where("Folio", "==", this.input_folio));
      }
      if (this.input_cajero != "") {
        filter.push(firestore.where("Cajero", "==", this.input_cajero));
      }
      if (this.selectCaja != "") {
        filter.push(firestore.where("Caja", "==", this.selectCaja));
      }
      return filter;
    },
    // Una query por bloque de 30 turnos (en vez de una por turno)
    queryPorTurnos(coleccion, turnos, filtros) {
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      return queryPorTurnos(firestore, coleccion, turnos, [
        firestore.where("Tenant", "==", this.$store.getters.getFirebaseApp.tenant),
        ...filtros,
      ]);
    },
    async fetchVentas(turnos) {
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      if (this.input_id != "") {
        const data = await firestore.getDoc(
          firestore.doc("PDV_Ventas", this.input_id)
        );
        return data.exists() ? [{ id: data.ref.id, ...data.data() }] : [];
      }
      const filtros = this.filtrosBusqueda(firestore);
      if (this.selectDep != "ALL" && this.selectDep != "") {
        filtros.push(firestore.where("Departamento", "==", this.selectDep));
      }
      return this.queryPorTurnos("PDV_Ventas", turnos, filtros);
    },
    fetchDevoluciones(turnos) {
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      return this.queryPorTurnos(
        "PDV_Devoluciones",
        turnos,
        this.filtrosBusqueda(firestore)
      );
    },
    async buscar() {
      if (this.loadingData) return;
      this.loadingData = true;
      try {
        const turnos = this.turnosSeleccionados();
        const [ventasDocs, devsDocs] = await Promise.all([
          this.fetchVentas(turnos),
          this.fetchDevoluciones(turnos),
        ]);

        const currency = Currencies.getCurrencyDefault();
        const ctx = {
          currency,
          filtrarPagos: this.pagos.length > 0,
          clavesPermitidas: new Set(
            this.pagos.flatMap((p) => this.monedas.map((m) => p + "_" + m))
          ),
          clientes: this.clientesSelected.length
            ? new Set(this.clientesSelected)
            : null,
          pagosNombres: new Map(
            this.getPDVPagosTipos.map((p) => [p.id, p.Nombre])
          ),
          meseros: new Map(this.meseros.map((m) => [m.id, m])),
        };

        const ventas = buildVentaRows(ventasDocs, ctx);
        const devs = buildDevolucionRows(devsDocs, ctx);
        this.contadoresTotales = Object.freeze(
          buildContadores(ventas, devs, ventasDocs, devsDocs, currency)
        );
        this.data_ventas = Object.freeze(ventas);
        this.data_devoluciones = Object.freeze(devs);
      } catch (err) {
        console.error("Error cargando reporte de transacciones:", err);
      } finally {
        this.loadingData = false;
      }
    },
    async getCajeros() {
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/Cajeros"
        );

      if (snapshot.exists()) {
        this.cajeros = [];
        Object.keys(snapshot.val()).forEach((id) => {
          const toAdd = snapshot.val()[id];
          if (toAdd) {
            toAdd.Id = id;
            // ajustar usuarios antiguos
            this.cajeros.push(toAdd);
          }
        });
      }
    },
  },
  async mounted() {
    // los catálogos deben estar antes de armar las descripciones de turnos
    await Promise.all([this.getCajas(), this.getCajeros(), this.getMeserosAB()]);
    await this.getAperturas();
  },
  beforeMount: function () {
    this.$emit("useNav", true);
  },
};
</script>

<style scoped>
.backgroundProp {
  background-color: lightcyan;
}

.backgroundCamb {
  background-color: lightgoldenrodyellow;
}

.activeClass {
  background: #2185d075 !important;
}
</style>
